import Hatch from '../img/sm-hatch.png'
import Catalyst from '../img/sm-catalyst.png'
import Ikea from '../img/sm-ikea.jpeg'
import SeadReplicator from '../img/sm-seed.png'

export default [
    {
        id: 1,
        name: 'Catalyst Lab',
        description: 'Aims to accelerate startups and civil society organizations (CSO) through capacity building classes and collaboration between Changemakers and multi-sectoral stakeholders. By bringing together Changemakers from across industries, we focus on creating partnerships with impact-based innovation to solve complex environmental problems.        ',
        date: 'Apr 10, 2024',
        status: 'Ongoing',
        type: 'ACCELERATOR',
        image: Catalyst,
        catalog: "https://instellar.id/wp-content/uploads/2024/06/Logo-CCL.png"
    },
    {
        id: 2,
        name: 'Hatch x PEDE',
        description: 'Incubation programme to support green tech startups in fortifying sustainable business and impactful growth by leveraging digital excellence. Applications are now open!',
        date: 'Jul 11, 2024',
        status: 'Ongoing',
        type: 'ACCELERATOR',
        image: Hatch,
        catalog: "https://instellar.id/wp-content/uploads/2024/03/Logo-Hatch-x-PEDE-1.png"
    },
    {
        id: 3,
        name: 'Instellar x IKEA',
        description: 'Social Entrepreneurship Indonesia Accelerator is a program that aims to accelerate the improvement of the quality and quantity of social enterprises in Indonesia, especially located outside Java to bring a positive impact on society',
        date: 'Oct 20, 2024',
        status: 'Upcoming',
        type: 'INCUBATOR',
        image: Ikea,
        catalog: "https://instellar.id/wp-content/uploads/2023/09/Featured-Image-Wordpress-1024x536.png"
    },
    {
        id: 4,
        name: 'SEED Replicator',
        description: 'Aspiring entrepreneur with hands-on tools and business blueprints which are proven to be profitable, deliver combined environmental, social and economic benefits and are easily adapted to different contexts. The aspiring entrepreneur will be guided by the experts during Replicator Workshop to take first step toward starting a business',
        date: 'Des 10, 2024',
        status: 'Upcoming',
        type: 'INCUBATOR',
        image: SeadReplicator,
        catalog: "https://instellar.id/wp-content/uploads/2023/12/LOGO-REPLICATOR-Revisi-2-1024x536.png"
    }
]